import LongFormArticleTemplate from '@/components/LongFormArticleTemplate';
import { nycPages } from '@/data/nycPages';

export default function NycWhatIssuesCanElderLawPlanningHelpWithPage() {
  return <LongFormArticleTemplate page={nycPages['/nyc-what-issues-can-elder-law-planning-help-with/']} />;
}
